import { render, staticRenderFns } from "./ChatMessageModal.vue?vue&type=template&id=db7603a4&scoped=true&"
import script from "./ChatMessageModal.vue?vue&type=script&lang=js&"
export * from "./ChatMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageModal.vue?vue&type=style&index=0&id=db7603a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7603a4",
  null
  
)

export default component.exports